<template>
  <div class="blogPreview">
    <div class="container pt-4" v-if="post">
      <div class="d-flex justify-content-end mb-4">
        <!-- Refresh button -->
        <button class="btn btn-primary btn-sm align-self-center m-2" @click="fetchPost()">
          <i class="fad fa-sync"></i>&nbsp;&nbsp; Refresh
        </button>

        <!-- Export button -->
        <button class="btn btn-primary btn-sm align-self-center" @click="exportZip()">
          <i class="fad fa-file-archive"></i>&nbsp;&nbsp; Export ZIP
        </button>
      </div>
    </div>

    <div class="container-fluid" v-if="post">

      <!-- Featured Post -->
      <Card :_enableToggle="false">
        <template v-slot:title>Featured post preview</template>

        <template v-slot:content>
          <div class="d-flex">
            <!-- size: 2x/3x -->
            <img
              v-if="post.verticalThumbnail"
              :src="post.verticalThumbnail.dataUrl"
              alt="Vertical Thumbnail"
              style="width: 10rem; height: 15rem; margin: 0"
            />

            <div class="m-3"></div>

            <div class="d-flex flex-column">
              <h3 style="font-weight: bold">{{ post.title }}</h3>

              <p>{{ post.description }}</p>
            </div>
          </div>
        </template>
      </Card>

      <!-- gap -->
      <div class="m-3"></div>

      <!-- Post Preview -->
      <Card :_enableToggle="false" :_expand="true">
        <template v-slot:title>Post preview</template>
        <template v-slot:content>
          <div class="row justify-content-center">
            <div class="col-12 col-md-8 px-md-5">
              <!-- Title -->
              <div class="row no-gutters justify-content-center mt-0 mt-md-5 pt-1">
                <div class="col-12 col-md-8 text-center">
                  <h1 class="axiforma fw500 mt-1 mb-5 lh1-5 size2-7 pt-4 pt-md-0">
                    {{ post.titleHtml1 }}
                    <br />
                    <span class="highlight">{{ post.titleHtml2 }}</span>
                  </h1>
                </div>
              </div>

              <!-- Description -->
              <p class="text-center">{{ post.description }}</p>

              <!-- Horizontal thumbnail -->
              <img
                :src="post.horizontalThumbnail.dataUrl"
                alt=""
                srcset=""
                v-if="post.horizontalThumbnail"
              />

              <!-- preview content -->
              <div v-html="post.htmlPreview"></div>
            </div>
          </div>
        </template>
      </Card>

      <!-- gap -->
      <div class="m-3"></div>

      <!-- Markdown -->
      <Card :_expand="false">
        <template v-slot:title>Markdown</template>
        <template v-slot:content>
          <div>
            <pre><code class="language-markdown">{{post.head}}</code></pre>
            <pre><code class="language-markdown">{{post.content}}</code></pre>
          </div>
        </template>
      </Card>
    </div>

    <!-- gap -->
    <div class="m-5"></div>
  </div>
</template>

<script>
import Editor from "@/components/Editor.vue";
import Card from "@/components/Card.vue";
import { exportPost } from "@/services/export";
import { getDB } from "@/services/db";

export default {
  name: "Preview",
  components: { Editor, Card },
  data() {
    return {
      post: null,
    };
  },

  async created() {
    await this.fetchPost();
  },

  mounted() {

    // auto update content
    window.addEventListener("storage", (event) => {
      if (event.key === "lastSavetAt") {
        this.fetchPost();
      }
    });
  },

  methods: {
    async fetchPost() {
      this.post = await getDB();
      console.log(this.post);
    },

    exportZip() {
      exportPost(this.post);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/_blogPreview.scss";
div,
p,
label,
span,
input,
button,
table,
td,
tr,
h1,
h2,
h3,
h4,
h5,
b,
a {
  font-family: "Source Serif Pro", serif !important;
}
</style>
